import { render } from "./step6.vue?vue&type=template&id=3124031e&scoped=true"
import script from "./step6.vue?vue&type=script&lang=js"
export * from "./step6.vue?vue&type=script&lang=js"

import "./step6.vue?vue&type=style&index=0&id=3124031e&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3124031e"]])

export default __exports__